<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type='primary' v-if="type === 1 || type === 2" @click="save" :loading="btnLoading">保存</el-button>
      <vxe-button type='primary' v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode"
        icon='el-icon-connection' status="">
        {{ btn.btnname }}
      </vxe-button>
    </div>
    <div class="main">
      <el-form :model="cos" ref="ruleForm" label-position="right" class="mainfrom from_input">
        <div class="row">
          <el-form-item label="子平台代号" prop="coscode" verify>
            <el-input v-model="cos.coscode" :maxlength="4" show-word-limit :disabled="chgdisable"></el-input>
          </el-form-item>
          <el-form-item label="子平台名称" prop="cosname" :verify="validateCosname">
            <el-input v-model="cos.cosname" :maxlength="60" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
          <!--<el-form-item label="发起单位">-->
          <!--<el-select v-model="cos.coscomid" :clearable="true" :disabled="disable">-->
          <!--<el-option v-for="(item, index) in comList" :label="item.comfullname" :value="item.comid"-->
          <!--:key="index"></el-option>-->
          <!--</el-select>-->
          <!--</el-form-item>-->
        </div>

        <div class="row">
          <el-form-item label="子平台版本" prop="cosver" verify>
            <el-input v-model="cos.cosver" :maxlength="128" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="子平台类型" prop="cosflg" verify>
            <div>
              <el-radio-group v-model="cos.cosflg">
                <el-radio @change="changecosPTtype" :label="1">主网站平台</el-radio>
                <el-radio @change="changecosPTtype" :label="2">私有网站平台</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="网站URL" prop="cosreturnurl" verify>
            <el-input v-model="cos.cosreturnurl" :maxlength="255" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="cosaddr" verify>
            <el-input v-model="cos.cosaddr" :maxlength="255" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="子平台热线" prop="costel" verify>
            <el-input v-model="cos.costel" :maxlength="20" :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="初始访问量" prop="cosvisittotal" verify :gt="0">
            <el-input v-model="cos.cosvisittotal" :maxlength="11" :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="保证金限额" prop="coslimitamtprecent" verify :lt="100" :gte="0">
            <el-input placeholder="不能超过预算的百分比" v-model="cos.coslimitamtprecent" :disabled="disable">
              <template slot="append">%</template>
            </el-input>
            （0表示不受限）
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="协议号前缀" prop="cosptccodeprefix">
            <el-input v-model="cos.cosptccodeprefix" :maxlength="5" :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="项目号前缀" prop="cosprojectcodeprefix">
            <el-input v-model="cos.cosprojectcodeprefix" :maxlength="5" :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="协议编号位数" prop="cosptccodenumlen" verify :gt="0">
            <el-input v-model="cos.cosptccodenumlen" :maxlength="4" :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="编号生成方式" prop='cosptccodeflag' verify>
            <div>
              <el-radio v-model="cos.cosptccodeflag" :label="1">自动生成</el-radio>
              <el-radio v-model="cos.cosptccodeflag" :label="2">默认平台编号</el-radio>
            </div>
          </el-form-item>
          <!-- <el-form-item label="子平台版本" prop="cosptccodenumlen" verify>
            <el-input v-model="cos.cosver" :maxlength="128" show-word-limit :disabled="disable"></el-input>
          </el-form-item> -->
        </div>
        <div class="row">
          <el-form-item label="服务费查看" prop="cosshowfwf" verify :gt="0">
            <div>
              <el-radio v-model="cos.cosshowfwf" :label="1">不能</el-radio>
              <el-radio v-model="cos.cosshowfwf" :label="2">能</el-radio>
            </div>
          </el-form-item>
        </div>
        <div class="split-line"></div>
        <div class="row">
          <el-form-item label="子平台LOGO" prop="coslogourl" verify>
            <div class="file">
              <upload-pic-one @changed='setfile' :picUrl='cos.coslogourl' folderName='web' text="选择文件"></upload-pic-one>
            </div>
          </el-form-item>
          <el-form-item label="网站LOGO" prop="coslogourl" verify>
            <div class="file">
              <upload-pic-one @changed='setfile2' :picUrl='cos.cosweblogourl' folderName='web' text="选择文件">
              </upload-pic-one>
            </div>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="公章">
            <div class="file">
              <upload-pic-one @changed='setseal' :picUrl='cos.sealurl' folderName='web' text="选择文件"></upload-pic-one>
            </div>
          </el-form-item>
          <el-form-item label="平台二维码">
            <div class="file">
              <upload-pic-one @changed='setfile1' :picUrl='cos.cosqrcode' folderName='web' text="选择文件"></upload-pic-one>
            </div>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="QQ客服二维码">
            <div class="file">
              <upload-pic-one @changed='setsealqq' :picUrl='cos.cosonlineqq' folderName='web' text="选择文件">
              </upload-pic-one>
            </div>
          </el-form-item>
        </div>
        <div v-if="type === 1">
          <div class="split-line"></div>
          <div class="row">
            <el-form-item label="运维单位名称" alias="运维单位名称" prop="comfullname" verify>
              <el-input v-model="cos.comfullname" :maxlength="80" show-word-limit :disabled="disable"></el-input>
            </el-form-item>
            <el-form-item label="统一信用代码" alias="统一信用代码" prop="comidcode" verify>
              <el-input v-model="cos.comidcode" :maxlength="50" show-word-limit :disabled="disable"></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="手机号码" alias="手机号码" prop="commobile" verify>
              <el-input v-model="cos.commobile" :maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="联系人" alias="联系人" prop="comcontact" verify>
              <el-input v-model="cos.comcontact" :maxlength="20" show-word-limit></el-input>
            </el-form-item>
          </div>
          <el-form-item label="联系人手机" alias="联系人电话" prop="comtel" verify>
            <el-input v-model="cos.comtel" :maxlength="20"></el-input>
          </el-form-item>
        </div>
        <div class="split-line"></div>
        <el-form-item label="报名费发票信息" alias="报名费发票信息" prop="cosfpxx" verify>
          <el-input type="textarea" v-model="cos.cosfpxx" :maxlength="255" show-word-limit></el-input>
        </el-form-item>
        <div class="split-line"></div>
        <div>
          <div class="row">
            <el-form-item label="微信商户号码" alias="商户号码" prop="cosmerchantNumber" verify>
              <el-input v-model="cos.cosmerchantNumber" :maxlength="255" show-word-limit :disabled="disable"></el-input>
            </el-form-item>
            <el-form-item label="微信公众号ID" alias="微信公众号ID" prop="coswxPublicAccountId" verify>
              <el-input v-model="cos.coswxPublicAccountId" :maxlength="255" show-word-limit :disabled="disable">
              </el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="微信安全私钥" alias="微信安全私钥" prop="coswxSecurityPrivateKey" verify>
              <el-input v-model="cos.coswxSecurityPrivateKey" :maxlength="255" show-word-limit :disabled="disable">
              </el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="微信支付证书">
              <div class="file">
                <div class="uploadbtn">
                  <upload-btn @changed='setfileWX' text="上传附件"></upload-btn>
                </div>
                <div style="color: #2f74ff;cursor: pointer;margin:10px 0;" v-if="wxPublicKeyList.appendfromtype">
                  <span @click="downFile(wxPublicKeyList.appendurl)" style="display:inline-block;padding-right: 20px;">
                    <a :src="$store.getters.uploadAddr + wxPublicKeyList.appendurl">{{ wxPublicKeyList.appendfilename
                    }}</a>
                  </span>
                  <a @click="delappendWX(wxPublicKeyList)" v-if="wxPublicKeyList.appendurl">删除</a>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="支付宝应用id" alias="支付宝应用id" prop="cosalipayApplicationId" verify>
              <el-input v-model="cos.cosalipayApplicationId" :maxlength="255" show-word-limit :disabled="disable">
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <el-form-item label="支付宝公钥">
            <div class="file">
              <div class="uploadbtn">
                <upload-btn @changed='setfileAliO' text="上传附件"></upload-btn>
              </div>
              <div style="color: #2f74ff;cursor: pointer;margin:10px 0;" v-if="alipayPublicKeyList.appendfromtype">
                <span @click="downFile(alipayPublicKeyList.appendurl)"
                  style="display:inline-block;padding-right: 20px;">
                  <a :src="$store.getters.uploadAddr + alipayPublicKeyList.appendurl">{{
                      alipayPublicKeyList.appendfilename
                  }}</a>
                </span>
                <a @click="delappendAliO(alipayPublicKeyList)" v-if="alipayPublicKeyList.appendurl">删除</a>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="支付宝应用私匙">
            <div class="file">
              <div class="uploadbtn">
                <upload-btn @changed='setfileAlit' text="上传附件"></upload-btn>
              </div>
              <div style="color: #2f74ff;cursor: pointer;margin:10px 0;" v-if="alipayPrivateKeyList.appendfromtype">
                <span @click="downFile(alipayPrivateKeyList.appendurl)"
                  style="display:inline-block;padding-right: 20px;">
                  <a :src="$store.getters.uploadAddr + alipayPrivateKeyList.appendurl">{{
                      alipayPrivateKeyList.appendfilename
                  }}</a>
                </span>
                <a @click="delappendAlit(alipayPrivateKeyList)" v-if="alipayPrivateKeyList.appendurl">删除</a>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="split-line"></div>
        <div class="content">
          <el-form-item label="子平台协议">
            <div ref="editor_xy" style="text-align:left"></div>
          </el-form-item>
        </div>
        <div class="split-line"></div>
        <div class="content">
          <el-form-item label="报价必读(反向)">
            <div ref="editor_bjbd" style="text-align:left"></div>
          </el-form-item>
          <el-form-item label="报价必读(正向)">
            <div ref="editor_zxbjbd" style="text-align:left"></div>
          </el-form-item>
          <el-form-item label="投标必读">
            <div ref="editor_tbbd" style="text-align:left"></div>
          </el-form-item>
          <el-form-item label="开标必读">
            <div ref="editor_kbbd" style="text-align:left"></div>
          </el-form-item>
          <el-form-item label="竞拍必读(正向)">
            <div ref="editor_zxjp" style="text-align:left"></div>
          </el-form-item>
          <el-form-item label="竞拍必读(反向)">
            <div ref="editor_fxjp" style="text-align:left"></div>
          </el-form-item>
          <el-form-item label="综合比选必读">
            <div ref="editor_zhbx" style="text-align:left"></div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--<vggrid v-if="list.length" ref="xGrid" :list="list" tableheight="500" flexname="" :cols="cols"-->
    <!--:showfooter="false" :showPage="false" :resizable="true"-->
    <!--:needBlackRow="false" :needPopMenu="false" :canbeEdit="false"-->
    <!--@cellClick="cellClick">-->
    <!--</vggrid>-->

  </Container>
</template>

<script>
import request from '@/utils/request'
import vggrid from '../common/vggrid'
import utils from '../../assets/js/utils'
import config from '../../assets/config'
import uploadPicOne from '../common/uploadPicOne'
import common from '@/mixin/common'
import _ from 'lodash'
import E from 'wangeditor'
import uploadBtn from '../common/uploadBtn'

const SUCCESS = 1
export default {
  name: "cosform",
  mixins: [common],
  data() {
    return {
      cosid: '',
      cos: {},
      wxPublicKeyList: {},
      alipayPublicKeyList: {},
      alipayPrivateKeyList: {},
      type: Number(this.$route.params.type),
      disable: this.$route.params.type === 3 ? true : false,
      btnLoading: false,
      comList: [],
      list: [],
      cols: [
        { type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80 },
        { field: 'comfullname', fieldtype: 'C', title: '单位简称', calculExpr: '' },
        { field: 'username', fieldtype: 'C', title: '申请加入人', calculExpr: '' },
        { field: 'cositemtime', fieldtype: 'T', title: '加入时间', calculExpr: '', formatter: ['toDateString', ''] }
      ],
      editorContent_xy: '',
      editor_xy: '',
      editorContent_bjbd: '',
      editorContent_zxbjbd: '',
      editorContent_tbbd: '',
      editorContent_kbbd: '',
      editorContent_zxjp: '',
      editorContent_fxjp: '',
      editorContent_zhbx: '',
      editor_bjbd: '',
      editor_zxbjbd: '',
      editor_tbbd: '',
      editor_kbbd: '',
      editor_zxjp: '',
      editor_fxjp: '',
      editor_zhbx: '',
      chgdisable: false
    }
  },
  async activated() {
    await this.init()
    await this.getcosInfo()
    // this.getComList()
    // this.getCosItemList()
    await this.initEditor_xy()
    await this.initEditor_bjbd()
    await this.initEditor_zxbjbd()
    await this.initEditor_tbbd()
    await this.initEditor_kbbd()
    await this.initEditor_zxjp()
    await this.initEditor_fxjp()
    await this.initEditor_zhbx()
    await this.getWXAppends()
    await this.getAlioAppends()
    await this.getAlitAppends()

  },
  created() {
  },
  mounted() {
  },
  watch: {},
  filters: {},
  components: { vggrid, uploadPicOne, uploadBtn },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr
    }
  },
  deactivated() {
    this.$destroy()
  },
  methods: {
    validateComfullname(rul, val, callback) {
      this.validateData('该单位全称已存在', 'comrec', 'comid', 'comfullname', val, callback)
    },
    validateCosname(rul, val, callback) {
      this.cos.cosname = _.trim(val)
      this.validateData('该平台名称已存在', 'cosrec', 'cosid', 'cosname', val, callback)
    },
    validateData(msg, tablename, fieldid, checkfield, checkval, callback) {
      request({
        url: '/validate/validateData',
        method: "post",
        data: { tablename, fieldid, checkfield, checkval: this.cos[checkfield], id: this.cos.cosid }
      }).then(res => {
        res === SUCCESS ? callback(Error(msg)) : callback()
      })
    },
    // changecosPT(val){
    //   if(val === 1){
    //     this.cos.cosflg = false
    //   }
    // },
    changecosPTtype(val) {
      this.cos.cosflg = val
    },
    async setfileWX(path, filename) {
      this.wxPublicKeyList = {
        appendid: 0,
        appendfromid: this.cosid,
        appendfromtype: '86',
        appendtype: '100',
        appendseq: 1,
        appendfilecode: '',
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, '')
      }
      this.cos.coswxPublicKey = path.replace(this.uploadAddr, '')
    },
    async setfileAliO(path, filename) {
      this.alipayPublicKeyList = {
        appendid: 0,
        appendfromid: this.cosid,
        appendfromtype: '87',
        appendtype: '100',
        appendseq: 1,
        appendfilecode: '',
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, '')
      }
      this.cos.cosalipayPublicKey = path.replace(this.uploadAddr, '')
    },
    async setfileAlit(path, filename) {
      this.alipayPrivateKeyList = {
        appendid: 0,
        appendfromid: this.cosid,
        appendfromtype: '88',
        appendtype: '100',
        appendseq: 1,
        appendfilecode: '',
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, '')
      }
      this.cos.cosalipayPrivateKey = path.replace(this.uploadAddr, '')
    },
    delappendWX(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, '提示', {
        type: 'warning'
      }).then(() => {
        this.wxPublicKeyList = {}
        this.cos.coswxPublicKey = ''
      }).catch(() => {
      })
    },
    delappendAliO(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, '提示', {
        type: 'warning'
      }).then(() => {
        this.alipayPublicKeyList = {}
        this.cos.cosalipayPublicKey = ''
      }).catch(() => {
      })
    },
    delappendAlit(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, '提示', {
        type: 'warning'
      }).then(() => {
        this.alipayPrivateKeyList = {}
        this.cos.cosalipayPrivateKey = ''
      }).catch(() => {
      })
    },
    async getWXAppends() {
      let res = await request({
        method: 'get',
        url: '/ywgl/append/getAppendListByFromId',
        params: { appendfromid: this.cosid, appendfromtype: '86' }
      })
      if (res.length > 0)
        this.wxPublicKeyList = res[0]
    },
    async getAlioAppends() {
      let res = await request({
        method: 'get',
        url: '/ywgl/append/getAppendListByFromId',
        params: { appendfromid: this.cosid, appendfromtype: '87' }
      })
      if (res.length > 0)
        this.alipayPublicKeyList = res[0]
    },
    async getAlitAppends() {
      let res = await request({
        method: 'get',
        url: '/ywgl/append/getAppendListByFromId',
        params: { appendfromid: this.cosid, appendfromtype: '88' }
      })
      if (res.length > 0)
        this.alipayPrivateKeyList = res[0]
    },
    async init() {
      this.cosid = this.$route.params.form.cosid
      this.cos.cosflg = Number(this.cos.cosflg)
      this.type = Number(this.$route.params.type)
      this.disable = this.$route.params.type === 3 ? true : false
      this.list = []
      this.editorContent_xy = ''
      this.editor_xy = ''
      this.editorContent_bjbd = ''
      this.editor_bjbd = ''
      this.editor_kbbd = ''
      this.editor_tbbd = ''
      this.editor_zhpx = ''
      this.wxPublicKeyList = { appendurl: '', appendfromtype: '', appendfromid: this.cos.cosid }
      this.alipayPublicKeyList = { appendurl: '', appendfromtype: '', appendfromid: this.cos.cosid }
      this.alipayPrivateKeyList = { appendurl: '', appendfromtype: '', appendfromid: this.cos.cosid }

      if (+this.$route.params.type === 2 || +this.$route.params.type === 3) {
        this.chgdisable = true
      }
    },
    async getcosInfo() {
      let res = await request({
        method: 'get',
        url: '/ywgl/cos/getCosbyid',
        params: { cosid: this.cosid }
      })
      this.cos = res[0]
      this.cos.cosflg = Number(this.cos.cosflg)
      this.editorContent_xy = this.cos.cosagreement
      this.editorContent_bjbd = this.cos.cosbjreadinfo
      this.editorContent_tbbd = this.cos.costbreadinfo
      this.editorContent_kbbd = this.cos.coskbreadinfo
      this.editorContent_zxbjbd = this.cos.coszxbjreadinfo
      this.editorContent_zxjp = this.cos.cosjpzxbjreadinfo
      this.editorContent_fxjp = this.cos.cosjpfxbjreadinfo
      this.editorContent_zhpx = this.cos.coszhbxreadinfo
    },
    async initEditor_xy() {
      if (this.editor_xy) {
        this.editor_xy.txt.html(this.cos.cosagreement)
        return
      }
      this.editor_xy = new E(this.$refs.editor_xy)
      this.editor_xy.config.onchange = (html) => {
        this.editorContent_xy = html
      }
      this.editor_xy.config.uploadFileName = 'file'
      this.editor_xy.config.uploadImgServer = `${config.baseUrl}upload/upload`
      this.editor_xy.config.zIndex = 1
      this.editor_xy.create()
      this.editor_xy.txt.html(this.cos.cosagreement)
    },
    async initEditor_bjbd() {
      if (this.editor_bjbd) {
        this.editor_bjbd.txt.html(this.cos.cosbjreadinfo)
        return
      }
      this.editor_bjbd = new E(this.$refs.editor_bjbd)
      this.editor_bjbd.config.onchange = (html) => {
        this.editorContent_bjbd = html
      }
      this.editor_bjbd.config.uploadFileName = 'file'
      this.editor_bjbd.config.uploadImgServer = `${config.baseUrl}upload/upload`
      this.editor_bjbd.config.zIndex = 1
      this.editor_bjbd.create()
      this.editor_bjbd.txt.html(this.cos.cosbjreadinfo)

    },
    async initEditor_zxbjbd() {//正向竞价
      if (this.editor_zxbjbd) {
        this.editor_zxbjbd.txt.html(this.cos.coszxbjreadinfo)
        return
      }
      this.editor_zxbjbd = new E(this.$refs.editor_zxbjbd)
      this.editor_zxbjbd.config.onchange = (html) => {
        this.editorContent_zxbjbd = html
      }
      this.editor_zxbjbd.config.uploadFileName = 'file'
      this.editor_zxbjbd.config.uploadImgServer = `${config.baseUrl}upload/upload`
      this.editor_zxbjbd.config.zIndex = 1
      this.editor_zxbjbd.create()
      this.editor_zxbjbd.txt.html(this.cos.coszxbjreadinfo)

    },
    async initEditor_kbbd() {//开标必读
      if (this.editor_kbbd) {
        this.editor_kbbd.txt.html(this.cos.coskbreadinfo)
        return
      }
      this.editor_kbbd = new E(this.$refs.editor_kbbd)
      this.editor_kbbd.config.onchange = (html) => {
        this.editorContent_kbbd = html
      }
      this.editor_kbbd.config.uploadFileName = 'file'
      this.editor_kbbd.config.uploadImgServer = `${config.baseUrl}upload/upload`
      this.editor_kbbd.config.zIndex = 1
      this.editor_kbbd.create()
      this.editor_kbbd.txt.html(this.cos.coskbreadinfo)

    },
    async initEditor_zxjp() {//正向竞拍
      if (this.editor_zxjp) {
        this.editor_zxjp.txt.html(this.cos.cosjpzxbjreadinfo)
        return
      }
      this.editor_zxjp = new E(this.$refs.editor_zxjp)
      this.editor_zxjp.config.onchange = (html) => {
        this.editorContent_zxjp = html
      }
      this.editor_zxjp.config.uploadFileName = 'file'
      this.editor_zxjp.config.uploadImgServer = `${config.baseUrl}upload/upload`
      this.editor_zxjp.config.zIndex = 1
      this.editor_zxjp.create()
      this.editor_zxjp.txt.html(this.cos.cosjpzxbjreadinfo)
    },
    async initEditor_fxjp() {//反向竞拍
      if (this.editor_fxjp) {
        this.editor_fxjp.txt.html(this.cos.cosjpfxbjreadinfo)
        return
      }
      this.editor_fxjp = new E(this.$refs.editor_fxjp)
      this.editor_fxjp.config.onchange = (html) => {
        this.editorContent_fxjp = html
      }
      this.editor_fxjp.config.uploadFileName = 'file'
      this.editor_fxjp.config.uploadImgServer = `${config.baseUrl}upload/upload`
      this.editor_fxjp.config.zIndex = 1
      this.editor_fxjp.create()
      this.editor_fxjp.txt.html(this.cos.cosjpfxbjreadinfo)
    },
    async initEditor_zhbx() {//综合比选
      if (this.editor_zhbx) {
        this.editor_zhbx.txt.html(this.cos.coszhbxreadinfo)
        return
      }
      this.editor_zhbx = new E(this.$refs.editor_zhbx)
      this.editor_zhbx.config.onchange = (html) => {
        this.editorContent_zhbx = html
      }
      this.editor_zhbx.config.uploadFileName = 'file'
      this.editor_zhbx.config.uploadImgServer = `${config.baseUrl}upload/upload`
      this.editor_zhbx.config.zIndex = 1
      this.editor_zhbx.create()
      this.editor_zhbx.txt.html(this.cos.coszhbxreadinfo)
    },
    async initEditor_tbbd() {//投标必读
      if (this.editor_tbbd) {
        this.editor_tbbd.txt.html(this.cos.costbreadinfo)
        return
      }
      this.editor_tbbd = new E(this.$refs.editor_tbbd)
      this.editor_tbbd.config.onchange = (html) => {
        this.editorContent_tbbd = html
      }
      this.editor_tbbd.config.uploadFileName = 'file'
      this.editor_tbbd.config.uploadImgServer = `${config.baseUrl}upload/upload`
      this.editor_tbbd.config.zIndex = 1
      this.editor_tbbd.create()
      this.editor_tbbd.txt.html(this.cos.costbreadinfo)

    },
    async cellActived(row) {
    },
    async cellClick(row) {
      this.cositem = row.row
    },
    async setfile(path, filename) {
      // this.cos.coslogourl = path.replace(this.uploadAddr,'')
      this.$set(this.cos, 'coslogourl', path.replace(this.uploadAddr, ''))
    },
    // 公章
    async setseal(path, filename) {
      this.cos.appends = []
      this.$set(this.cos, 'sealurl', path.replace(this.uploadAddr, ''))
      // this.cos.sealurl = path.replace(this.uploadAddr,'')
      this.cos.appends.push({
        appendfromid: this.cos.cosid,
        appendfromtype: 8,
        appendfilename: filename,
        appendtype: 4,
        appendfilecode: '',
        appendseq: 1,
        appendurl: path.replace(this.uploadAddr, '')
      })
    },
    async setfile1(path, filename) {
      // this.cos.cosqrcode = path.replace(this.uploadAddr,'')
      this.$set(this.cos, 'cosqrcode', path.replace(this.uploadAddr, ''))
    },
    async setsealqq(path, filename) {
      this.$set(this.cos, 'cosonlineqq', path.replace(this.uploadAddr, ''))
    },
    async setfile2(path, filename) {
      // this.cos.cosweblogourl = path.replace(this.uploadAddr,'')
      this.$set(this.cos, 'cosweblogourl', path.replace(this.uploadAddr, ''))
    },
    async setfile3(path, filename) {
      // 支付宝应用公钥
      this.$set(this.cos, 'alipayPublicKey', path.replace(this.uploadAddr, ''))
    },
    async setfile4(path, filename) {
      // 支付宝应用私匙
      this.$set(this.cos, 'alipayPrivateKey', path.replace(this.uploadAddr, ''))
    },
    async setfile5(path, filename) {
      // 支付宝应用公钥
      this.$set(this.cos, 'coswxPublicKey', path.replace(this.uploadAddr, ''))
    },
    async getComList() {
      this.loading = true
      let res = await request({
        method: 'get',
        url: '/ywgl/com/getComList',
        params: {}
      })
      // this.editorContent_xy = this.cos.cosagreement
      // this.editorContent_bjbd = this.cos.cosbjreadinfo
      // this.editorContent_tbbd = this.cos.costbreadinfo
      // this.editorContent_kbbd = this.cos.coskbreadinfo

      this.comList = res
      this.loading = false
    },
    async getCosItemList() {
      this.loading = true
      let res = await request({
        method: 'get',
        url: '/ywgl/cos/getCosItemList',
        params: { cosid: this.cos.cosid }
      })
      this.list = res
      this.loading = false
    },
    async save() {
      if (!this.wxPublicKeyList.appendfromtype) {
        this.$message.warning('请上传微信支付证书');
        return
      }
      if (!this.alipayPublicKeyList.appendfromtype) {
        this.$message.warning('请上传支付宝公钥');
        return

      }
      if (!this.alipayPrivateKeyList.appendfromtype) {
        this.$message.warning('请上传支付宝应用私匙');
        return
      }
      this.submitForm('ruleForm').then(async () => {
        this.cos.cosuserid = this.$store.getters.loginUser.userid
        this.cos.cosagreement = this.editorContent_xy
        this.cos.cosbjreadinfo = this.editorContent_bjbd
        this.cos.coskbreadinfo = this.editorContent_kbbd
        this.cos.costbreadinfo = this.editorContent_tbbd
        this.cos.coszxbjreadinfo = this.editorContent_zxbjbd
        this.cos.cosjpzxbjreadinfo = this.editorContent_zxjp
        this.cos.cosjpfxbjreadinfo = this.editorContent_fxjp
        this.cos.coszhbxreadinfo = this.editorContent_zhbx
        this.cos.wxPublicKeyList = this.wxPublicKeyList
        this.cos.alipayPublicKeyList = this.alipayPublicKeyList
        this.cos.alipayPrivateKeyList = this.alipayPrivateKeyList

        let data = await request({
          url: '/ywgl/cos/addOrEdit',
          method: "post",
          data: this.cos
        })
        if (data.issuccess === 1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          if (data.msg) {
            this.$message.warning(data.msg)
          } else {
            this.$message.error('保存失败')
          }
        }

      }).catch(() => {
      })
    },
    close() {
      this.$store.commit('close_tab', { routeName: this.$route.name, vm: this, newRouteName: 'cosIndex' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/filelist";

.main {

  .from_input .el-input,
  .el-input .el-input__inner,
  .el-select,
  .file {
    width: 280px;
  }

  content .el-textarea__inner,
  .el-textarea {
    width: 840px;
  }

}
</style>
